var map = {
	"./aparat.png": 27229,
	"./bilibili.svg": 42960,
	"./boomstream.svg": 66017,
	"./breakerstv.svg": 89397,
	"./colored/bilibili.svg": 40553,
	"./colored/boomstream.svg": 71772,
	"./colored/breakerstv.svg": 34224,
	"./colored/custom.svg": 64688,
	"./colored/cybergame.svg": 87590,
	"./colored/discord.png": 46377,
	"./colored/discord.svg": 61307,
	"./colored/djlive.png": 4797,
	"./colored/dlive.svg": 58525,
	"./colored/facebook-live.svg": 41268,
	"./colored/gg.svg": 37643,
	"./colored/instagib.svg": 88224,
	"./colored/lahzenegar.svg": 72554,
	"./colored/linkedin.svg": 34883,
	"./colored/liveedu.svg": 65989,
	"./colored/livehouse.svg": 5493,
	"./colored/livestream.svg": 4531,
	"./colored/meridix.svg": 1547,
	"./colored/mixcloud.svg": 12744,
	"./colored/mixer.svg": 13104,
	"./colored/mobcrush.svg": 1218,
	"./colored/nimotv.png": 43224,
	"./colored/nimotv.svg": 88808,
	"./colored/now.svg": 79719,
	"./colored/periscope.png": 91063,
	"./colored/periscope.svg": 42413,
	"./colored/phonelivestreaming.svg": 74247,
	"./colored/picartotv.svg": 89923,
	"./colored/sportscastr.svg": 54573,
	"./colored/steam.svg": 91139,
	"./colored/switchboard.svg": 95811,
	"./colored/thetatv.svg": 61389,
	"./colored/trovo.svg": 16335,
	"./colored/twitch.svg": 86352,
	"./colored/twitter.svg": 28154,
	"./colored/ustream.svg": 14198,
	"./colored/vaperstv.svg": 97112,
	"./colored/vaughnlive.svg": 38042,
	"./colored/vimeo-white-12dfb0dc.svg": 84966,
	"./colored/vimeo.svg": 93903,
	"./colored/vimmtv.png": 44050,
	"./colored/vimmtv.svg": 76410,
	"./colored/vk.png": 92804,
	"./colored/vk.svg": 49868,
	"./colored/webtv.svg": 27435,
	"./colored/younow.svg": 41758,
	"./colored/youtube.svg": 97312,
	"./custom.svg": 84385,
	"./cybergame.svg": 82097,
	"./discord.png": 79886,
	"./djlive.png": 26064,
	"./dlive.svg": 94778,
	"./facebook-live.svg": 97835,
	"./fb copy.svg": 95743,
	"./fb.svg": 38712,
	"./fc2.svg": 94233,
	"./gg.svg": 1962,
	"./instagib.svg": 98669,
	"./instagram.svg": 55308,
	"./lahzenegar.svg": 75687,
	"./linkedin.svg": 95830,
	"./liveedu.svg": 28422,
	"./livehouse.svg": 38566,
	"./livestream.svg": 64622,
	"./meridix.svg": 46968,
	"./mixcloud.svg": 84137,
	"./mixer.svg": 64883,
	"./mobcrush.svg": 84815,
	"./nimotv.svg": 76265,
	"./periscope.png": 95324,
	"./phonelivestreaming.svg": 68142,
	"./picartotv.svg": 70248,
	"./sportscastr.svg": 9030,
	"./steam.svg": 47840,
	"./stream-logo-light.png": 64517,
	"./switchboard.svg": 45596,
	"./thetatv.svg": 37542,
	"./tiktok.svg": 38798,
	"./trovo.svg": 44964,
	"./twitch.svg": 20861,
	"./twitter.svg": 30189,
	"./ustream.svg": 52005,
	"./vaperstv.svg": 81761,
	"./vaughnlive.svg": 13919,
	"./vimeo.svg": 21964,
	"./vimmtv.svg": 15875,
	"./vk.svg": 71681,
	"./wasd.svg": 83521,
	"./webtv.svg": 67240,
	"./x.svg": 30544,
	"./younow.svg": 78663,
	"./youtube.svg": 98483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42326;